module.exports = __webpack_public_path__ + "static/media/cloud-sun-rain.91cf5c87.svg";